export default "__VITE_ASSET__Bh4261L1__"